import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput
} from '@lightbeamhealth/blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxGenericSettingsData {
  afterHourInfo?: boolean;
}

const DefaultSettings: EpxGenericSettingsData = {
  afterHourInfo: false
};

interface EpxGenericSettingsProps {
  setForm?: (form: FormInstance<EpxGenericSettingsData>) => void;
  onSubmit?: (data: EpxGenericSettingsData) => void;
  disabled?: boolean;
}

const EpxGenericSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxGenericSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxGenericSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onSubmit = (data: EpxGenericSettingsData) => {
    _onSubmit({
      ...data
    });
  };
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Inform Business Hour"
                name="afterHourInfo"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxGenericSettings;
